import { ILinkText } from './link-text.interface'

const LinkText = ({ label, onClick, classname }: ILinkText) => {
    return (
        <p
            onClick={() => {
                onClick()
            }}
            className={`${classname} themes-text-link font-bold text-[14px] w-full`}
        >
            {label}
        </p>
    )
}

export default LinkText
